import GatewayService from '../GatewayService.js';
var thirdPartySecrets = new GatewayService('third-party-secrets');

var fetchIntercomUserHash = function fetchIntercomUserHash() {
  return thirdPartySecrets.get('intercom/keycloakUserHash');
};

var fetchLearnositySignature = function fetchLearnositySignature() {
  return thirdPartySecrets.get('learnosity/config');
};

var fetchQuillHash = function fetchQuillHash() {
  return thirdPartySecrets.get('quill/userHash');
};

export default {
  fetchIntercomUserHash: fetchIntercomUserHash,
  fetchLearnositySignature: fetchLearnositySignature,
  fetchQuillHash: fetchQuillHash
};